import React, { Component } from 'react';
import { Big3Common } from '../../js/IncludeManager';
import { GoodsPhoto } from '../../js/ComponentManager'
import { Link } from 'react-router-dom';

/* 개발담당:양유빈
 * 화면기능:리스트 상품
 * 세부설명:
*/

export class ListGoods extends Component {
    static displayName = ListGoods.name;

    constructor(props) {
        super(props);
        this.state = {
            ContentConmgr: { ...this.DataObject.ContentConmgr },
            TotalCount: 0,
            GoodsList: [],
            ContentTabList: [],
            SelectTabNo: "",
            Bgcolor: ""
           
        };
        this.handleGoodsDtl_Click = this.handleGoodsDtl_Click.bind(this);
        this.handleAddMore_Click = this.handleAddMore_Click.bind(this);
        this.handle_onScroll = this.handle_onScroll.bind(this);
        this.index = -1;
        this.listCount = -1;
    }
    //초기화
    componentDidMount() {
        
        window.addEventListener('scroll', this.handle_onScroll);

        const ContentConmgr = Big3Common.Util.GetContentState(this.props, "data-info", null);
        this.index = Big3Common.Util.GetContentState(this.props, "index", -1);
        this.listCount = Big3Common.Util.GetContentState(this.props, "listcount", -1);
       
        if (ContentConmgr !== null) {
            this.setState({ ContentConmgr: ContentConmgr }, () => {
                this.GetMainGoodsList(false);
            });
        }
    }
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handle_onScroll);
    } 
    DataObject = {
        ContentConmgr: {
            mgr_no: "",
            title: "",
            cntt_tye: "",
            fltr_tye: "",
            ui_tye: "",
            width_cnt: "",
            len_cnt: "",
            tab_use_yn: ""  //스와이프에서 탭은 미적용
        }
    }
    SearchModel = {
        Page_Number: 1,
        Page_Size: 6,
        mgr_no: 0,
        tab_no:"",
        fltr_tye: "MA"
    }
    GetMainGoodsList = async (isAppend = false) => {
        try {
            Big3Common.Util.LoadingOn();
            this.SearchModel.Page_Size = (parseInt(this.state.ContentConmgr.width_cnt) * this.state.ContentConmgr.len_cnt);
            this.SearchModel.mgr_no = this.state.ContentConmgr.mgr_no;
            const Data = await Big3Common.Post("api/AdMgr/HomeAd/GetMainSettingList",
                this.SearchModel, true);
            if (Data.codeName === Big3Common.ResultCode.Success) {

                const multiDataTable = JSON.parse(Data.multiDataTable);
                const DataList = multiDataTable.goodsList;
                const TabList = multiDataTable.content_tab_list;
                const Bgcolor = multiDataTable.bgcolor;

                let DefaultTabNo = "";
                if (TabList.length > 0 && this.state.SelectTabNo === "") {
                    DefaultTabNo = TabList[0].tab_no;
                    this.setState({
                        SelectTabNo: DefaultTabNo,
                        Bgcolor: Bgcolor
                    });
                }

                const TotalCount = (this.SearchModel.Page_Number * this.SearchModel.Page_Size);
                if (isAppend) {
                    //페이징 처리
                    let GoodListPush = this.state.GoodsList;
                    DataList.map(list => GoodListPush.push(list));
                    this.setState({
                        GoodsList: GoodListPush,
                        TotalCount: TotalCount
                    });
                }
                else {
                    this.setState({
                        GoodsList: DataList,
                        TotalCount: TotalCount,
                        ContentTabList: TabList
                    });
                }

            }
            else {
                console.log(Data.message, `${this.SearchModel.mgr_no}번`);
            }
        }
        catch (e) {
            console.log("GetMainGoodsList", e);
        }
        finally {
            Big3Common.Util.LoadingOff();
            Big3Common.WebConfig.ScrollEvent = true;
        }
    }
    handle_onScroll() {
        if (this.listCount > 0 && (this.listCount - 1) === this.index) {
            if (Big3Common.WebConfig.ScrollEvent === false) {
                return false;
            }
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 1) {
                Big3Common.WebConfig.ScrollEvent = false;
                this.handleAddMore_Click()
            }
        }
        
    }
    handleGoodsDtl_Click = (event, goods_no, uid) => {
        const GoodsDtlShow = this.props.GoodsDtlShow;
        const mgr_no=this.state.ContentConmgr.mgr_no
        if (GoodsDtlShow !== undefined && GoodsDtlShow !== null) {
            GoodsDtlShow(goods_no, uid, mgr_no);
        }
        event.preventDefault();
    }
    handleAddMore_Click() {
        this.SearchModel.Page_Number++;
        this.GetMainGoodsList(true);
        //로그기록(더보기)
        Big3Common.RegisterTrackingLog({
            [Big3Common.ContentState.Page_cd]: "MM",
            [Big3Common.ContentState.Basket_Yn]: "N"
        });
        return false;
    }
    handleTab_Clcik(e, tab_no) {
        this.SearchModel.Page_Number=1;
        this.SearchModel.tab_no = tab_no;
        this.setState({ SelectTabNo: tab_no }, () => {
            this.GetMainGoodsList(false);
        });
    }
    Tabrender = () => {
        const ContentTabList = this.state.ContentTabList;
        if (ContentTabList.length === 0) return false;
        return (
            <div className="select_category">
                {ContentTabList.map(list =>
                    <div key={list.tab_no}
                        className={list.tab_no === this.state.SelectTabNo ? "m_category select" : "m_category"}
                        onClick={(e) => { this.handleTab_Clcik(e, list.tab_no) }}>{list.tab_contt }</div>
                )}
            </div>
        )
    }
    GoodsBoxrender() {
        const ToDayBestList = this.state.GoodsList;
        const productCount = parseInt(this.state.ContentConmgr.len_cnt);
        const productClass = productCount === 2 ? "product2" : "product"; //2줄 or 3줄
        return (
            ToDayBestList.map((list, idx) =>
                <div className={productClass } key={idx}
                    onClick={(e) => { this.handleGoodsDtl_Click(e, list.goods_no, list.uid) }}
                >
                    <GoodsPhoto className="product_img" ImageSrc={list.img_220}
                        Bookmark={{ Goods_No: list.goods_no, Uid: list.uid, Bookmark_Yn: list.bookmark_yn }}
                        BackGround={true}
                        SimilarityYn="Y"
                    />
                    <div className="shop_name">{list.whole_name}</div>
                    <div className="product_name">{list.goods_nm}</div>
                    <div className="product_price">{list.strqst_yn === "Y" ? "매장문의" : `${Big3Common.Util.Money(list.goods_price)}원`}</div>
                    {/*<div className="views">조회수 {Big3Common.Util.Money(list.view_cnt)}건 </div>*/}
                </div>
            )
        )
    }
    render() {

        if (this.state.GoodsList.length === 0) return false;
        const LintAdress = `/AdMgr/ListGoodsMore?mgr_no=${this.state.ContentConmgr.mgr_no}`;
        const Css = `main_content ${this.state.Bgcolor}`
        return (
            <div className={Css } >
                <div className="rt_main_title_box">
                    <div className="title2">{Big3Common.Util.GetContentState(this.state.ContentConmgr, "title", "")}</div>
                    <Link to={LintAdress} >
                        <div className="more_view">더보기</div>
                    </Link>
                </div>
                {this.Tabrender() }
                <div className="today_poroducts row row-cols-3 ">
                    {this.GoodsBoxrender()}
                </div>
                {this.state.TotalCount === this.state.GoodsList.length ? <div className="more_btn_box2"><button className="more_btn2" onClick={this.handleAddMore_Click}>더 보기</button></div> : ""}
            </div>

        );
    }
}
